import { useEffect, useMemo } from 'react';
import { MultiSelect } from '../../../../../../../../features/multi-select/multi-select';
import { getValueFromOptions } from '../../../../../../../../helpers/mappers';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useEmployeesStore } from '../../../../../../../../store/use-employee-store';
import { useShiftsStore } from '../../../../../../../../store/use-shifts-store';
import { IdValue } from '../../../../../../../../types/props';
import s from './shifts-controls-schedule-modal-step-0.module.css';

export const ShiftsControlsScheduleModalStep0 = () => {
  const { t, getLocale } = useLang();
  const { fetchEmployees, staff } = useEmployeesStore();
  const { handleUpdateShift, shift } = useShiftsStore();

  useEffect(() => {
    fetchEmployees({ is_by_company: true, page: 1, page_size: 1000 });
  }, []);

  const options: IdValue[] = useMemo(
    () =>
      staff?.map((employee) => ({
        id: String(employee.id),
        value: `${getLocale(employee.name)} ${getLocale(employee.surname)}`,
      })) || [],
    [staff],
  );

  return (
    <div className={s.feature}>
      <h3>{t('Выбрать сотрудников')}</h3>
      <MultiSelect
        options={options}
        name="staffIds"
        onSelect={(e) => handleUpdateShift({ staffIds: e.map((item) => item.id) })}
        value={getValueFromOptions(options, shift?.staffIds)}
      />
    </div>
  );
};
